<template>
  <router-link
    :to="to"
    class=" font-semibold md:text-sm  lg:text-base  xl:text-lg border-b-4 border-transparent inline-flex items-center px-1 lg:px-2 xl:px-5 pt-1  font-medium leading-5  focus:outline-none  transition duration-150 ease-in-out uppercase
              "
    :exact-active-class="borderClass"
  >
    {{ title }}
  </router-link>
</template>

<script>
export default {
  name: "DarkNavLink",
  props: {
    title: {
      type: String
    },
    to: {
      type: String
    },
    borderClass: {
      type: String
    }
  }
};
</script>

<style scoped></style>
